module.exports = __webpack_public_path__ + "img/facebook-f-white.69ad6a02.svg";